import classnames from 'classnames/bind'
import { GlobalGridPreset } from '~/@types/grid-preset'

import AbstractPagination, {
  PaginationProps as AbstractPaginationProps,
} from '~/components/Abstracts/Pagination'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type PaginationProps = AbstractPaginationProps & {
  className?: string
}

function Pagination({ className, ...rest }: PaginationProps) {
  const gridStyle = useStyle({ grid: GlobalGridPreset.BASE_GRID })

  return (
    <div className={cx(css.Pagination, className, gridStyle)}>
      <AbstractPagination className={cx(css.content)} {...rest} />
    </div>
  )
}

Pagination.defaultProps = {}

export default Pagination
